// extracted by mini-css-extract-plugin
export default {"contract":"ContractAdmin_contract__hcZkg","code-scopes":"ContractAdmin_code-scopes__hQiNR","care-scopes":"ContractAdmin_care-scopes__J4icC"};